module.exports = __webpack_public_path__ + "img/bg-faqs.07dd73dc.png";